Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.default = void 0;

var _leaflet = _interopRequireDefault(require("leaflet"));
require("./NonTiledLayer");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _default = _leaflet.default.NonTiledLayer.extend({
  defaultWmsParams: {
    service: "WMS",
    request: "GetMap",
    version: "1.1.1",
    layers: "",
    styles: "",
    format: "image/jpeg",
    transparent: false,
  },

  options: {
    crs: null,
    uppercase: false,
  },

  initialize: function (url, options) {
    // (String, Object)
    this._wmsUrl = url;

    var wmsParams = _leaflet.default.extend({}, this.defaultWmsParams);

    // all keys that are not NonTiledLayer options go to WMS params
    for (var i in options) {
      if (
        !_leaflet.default.NonTiledLayer.prototype.options.hasOwnProperty(i) &&
        !(
          _leaflet.default.Layer &&
          _leaflet.default.Layer.prototype.options.hasOwnProperty(i)
        )
      ) {
        wmsParams[i] = options[i];
      }
    }

    this.wmsParams = wmsParams;

    _leaflet.default.setOptions(this, options);
  },

  onAdd: function (map) {
    this._crs = this.options.crs || map.options.crs;
    this._wmsVersion = parseFloat(this.wmsParams.version);

    var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
    this.wmsParams[projectionKey] = this._crs.code;

    _leaflet.default.NonTiledLayer.prototype.onAdd.call(this, map);
  },

  getImageUrl: function (bounds, width, height) {
    var wmsParams = this.wmsParams;
    wmsParams.width = width;
    wmsParams.height = height;

    var nw = this._crs.project(bounds.getNorthWest());
    var se = this._crs.project(bounds.getSouthEast());

    var url = this._wmsUrl;

    var bbox = (this._wmsVersion >= 1.3 &&
    this._crs === _leaflet.default.CRS.EPSG4326
      ? [se.y, nw.x, nw.y, se.x]
      : [nw.x, se.y, se.x, nw.y]
    ).join(",");

    return (
      url +
      _leaflet.default.Util.getParamString(
        this.wmsParams,
        url,
        this.options.uppercase
      ) +
      (this.options.uppercase ? "&BBOX=" : "&bbox=") +
      bbox
    );
  },

  setParams: function (params, noRedraw) {
    _leaflet.default.extend(this.wmsParams, params);

    if (!noRedraw) {
      this.redraw();
    }

    return this;
  },
});

exports.default = _default;
